/*!

=========================================================
* Black Dashboard React v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState , useEffect , useRef } from "react";
import "../assets/css/customcss.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // استایل اصلی Swiper
import "swiper/css/navigation"; // برای استفاده از ناوبری
import "swiper/css/pagination"; // برای استفاده از نقاط (pagination)
import { useLocation , Link } from "react-router-dom";
import axios from 'axios';
import apiConfig from "../config/apiConfig";
import moment from "jalali-moment";
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import html2canvas from 'html2canvas';
import { Table } from "reactstrap";

// reactstrap components
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";

function GetUser() {

  const [user, setUser] = useState([]);
  const [anthropometry, setAnthropometry] = useState([])
  const [dietOrder, setDietOrder] = useState([])
  const [importantQuestions, setImportantQuestions] = useState([])
  const [weightsSession, setWeightsSession] = useState([])
  const [startDateFa, setStartDateFa] = useState(null)
  const [startDateFa2, setStartDateFa2] = useState(null)
  const [typeOfDiet, setTypeOfDiet] = useState(null)
  const [nameWeeks, setNameWeeks] = useState(null)
  const [monthlyPicture, setMonthlyPicture] = useState([])
  const [dateDifference, setDateDifference] = useState(0)
  const serverUrl = apiConfig.serverUrl;
  const [weeklyInformation, setWeeklyInformation] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [userSurveys, setUserSurveys] = useState([]);
  const [conditions, setConditions] = useState(null);
  const [dailyActivity, setDailyActivity] = useState(null);

  const [questionnaireData, setQuestionnaireData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);






  const tableStyles = {
    container: {
      margin: "20px 0",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      borderRadius: "8px",
      overflow: "hidden",
      backgroundColor:'#111931'
    },
    headerRow: {
      backgroundColor: "rgb(33 129 247)",
      color: "white",
      textAlign: "center",
      fontWeight: "bold",
    },
    cell: {
      padding: "12px",
      textAlign: "center",
      borderBottom: "1px solid #ddd",
    },
    hoverRow: {
      transition: "background-color 0.2s ease",
    },
    hoverRowHovered: {
      backgroundColor: "#f9f9f9",
    },
    diseaseList: {
      padding: 0,
      listStyleType: "none",
    },
  };
 const diseaseContainerStyles = {
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
  justifyContent: "center",
};

const diseaseBoxStyles = {
  padding: "5px 10px",
  borderRadius: "6px",
  backgroundColor: "#e9f5ff",
  border: "1px solid #b0d4f1",
  fontSize: "12px",
  color: "#004085",
  textAlign: "center",
  minWidth: "80px",
  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
};

  // اطلاعات نمونه برای هر هفته
  const weekData = {
    "هفته اول": {
      weight: "75 کیلوگرم",
      calories: "2200 کالری",
      progress: "کاهش 1 کیلوگرم",
      notes: "در این هفته مصرف آب بیشتر از حد نیاز است.",
    },
    "هفته دوم": {
      weight: "74 کیلوگرم",
      calories: "2100 کالری",
      progress: "کاهش 1 کیلوگرم دیگر",
      notes: "ورزش‌های هوازی در این هفته پیشنهاد می‌شود.",
    },
    "هفته سوم": {
      weight: "73.5 کیلوگرم",
      calories: "2000 کالری",
      progress: "کاهش 0.5 کیلوگرم",
      notes: "تمرکز بیشتر روی خواب و ریکاوری.",
    },
    "هفته چهارم": {
      weight: "73 کیلوگرم",
      calories: "2000 کالری",
      progress: "کاهش 0.5 کیلوگرم",
      notes: "پایان دوره با نتایج عالی.",
    },
  };


  const location = useLocation();
  const userid = location.state?.userid;
  
  // تابع دریافت داده‌های پرسشنامه
  const fetchQuestionnaire = async () => {
    setLoading(true);
    try {
   
      let config = {};
      
   
        config = {
          params: {
            user_id: userid
          }
        };
     
  
      const response = await axios.get(`${serverUrl}questionnaire`, config);
      setQuestionnaireData(response.data);
      console.log(response.data.answers[0])
      
    } catch (err) {
      setError('خطا در دریافت داده‌های پرسشنامه');
      console.error('Error fetching questionnaire:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userid) {
      fetchQuestionnaire();
      setLoading(true);
      axios
        .get(`${serverUrl}surveys/user/${userid}`)
        .then((response) => {
          if (response.data.status) {
            setUserSurveys(response.data.surveys);
          }
        })
        .catch((error) => {
          console.error("خطا در دریافت نظرات: ", error);
        })
        .finally(() => setLoading(false));
    } else {
      setError('شناسه کاربر یا توکن احراز هویت مورد نیاز است');
      setLoading(false);
    }
  }, [userid]);
  
  useEffect(() => {
    if (userid) {
      fetchQuestionnaire();
    } else {
      setError('شناسه کاربر یا توکن احراز هویت مورد نیاز است');
      setLoading(false);
    }
  }, [userid]);




 useEffect(() => {
    const Usertoken = {
      headers: {
        userid: userid,
      },
    };
    axios
    .get(serverUrl + "get-user-info",Usertoken)
    .then((response) => {
      const User = response.data.User
      setUser(User)
      const monthly_picture = response.data.monthly_picture
      const ImportantQuestions = response.data.ImportantQuestions
      const dataFromServer = response.data.weekly_information
      const Conditions = response.data.Conditions
      const DailyActivity = response.data.DailyActivity

      setConditions(Conditions);
      setDailyActivity(DailyActivity);

      const optionsResult = [];
      if(dataFromServer != null)
      {
        console.log(dataFromServer)
        //const parsedData = dataFromServer.map(item => JSON.parse(item));
       // console.log(parsedData)
        setWeeklyInformation(dataFromServer);
      }
      else
      {
        setWeeklyInformation([]);
      }
      
if(ImportantQuestions.length > 0)
  {

    // بررسی و تبدیل مقادیر option1 تا option31
    for (let i = 1; i <= 31; i++) {
      const optionKey = `option${i}`; // ساخت کلید برای هر option
      const value = ImportantQuestions[optionKey] === "true" ? "بله" : "خیر";
      optionsResult.push({ [optionKey]: value }); // اضافه کردن به آرایه
    }
    setImportantQuestions(optionsResult)

  }
  else
  {
    setImportantQuestions([])
  }


    setMonthlyPicture(monthly_picture)




     
      
  
      const Anthropometry = response.data.Anthropometry
      const Anthropometry5 = response.data.Anthropometry5
      const DietOrder = response.data.DietOrder
      const DietMethod = response.data.DietMethod
      const FoodMenu = response.data.FoodMenu
      const OutputInformation = response.data.OutputInformation

      if(Anthropometry5.height_ce != 0)
      {
        var height = Anthropometry5.height_ce
      }
      else
      {
        var height = Anthropometry5.height_in * 2.54;
      }
      /*------------------*/
      
      if(Anthropometry5.initial_weight_kg !=0)
      {
        const newArray = Anthropometry5.initial_weight_kg.split(' ');
        if(newArray[1] > 0 )
        {
          var weight = newArray[0]+'.'+newArray[1]
           weight = parseFloat(weight);

        }
        else
        {
          var weight = newArray[0]
           weight = parseInt(weight, 10)
        }
      }
      else
      {
        const newArray = Anthropometry5.initial_weight_po.split(' ');
        if(newArray[1] > 0 )
        {
          var weight = newArray[0]+'.'+newArray[1]
           weight = parseFloat(weight);
           weight = weight * 0.453592;

        }
        else
        {
          var weight = newArray[0]
           weight = parseInt(weight, 10)
           weight = weight * 0.453592;
        }
        
      }
      
      
      setWeightsSession(response.data.dataArray)


      
      if(Anthropometry5.weight_kg !=0)
      {
        const newArray = Anthropometry5.weight_kg.split(' ');
        if(newArray[1] > 0 )
        {
          var weight2 = newArray[0]+'.'+newArray[1]
           weight2 = parseFloat(weight2);

        }
        else
        {
          var weight2 = newArray[0]
           weight2 = parseInt(weight2, 10)
        }
      }
      else
      {
        const newArray = Anthropometry5.weight_po.split(' ');
        if(newArray[1] > 0 )
        {
          var weight2 = newArray[0]+'.'+newArray[1]
           weight2 = parseFloat(weight2);
           weight2 = weight2 * 0.453592;

        }
        else
        {
          var weight2 = newArray[0]
           weight2 = parseInt(weight2, 10)
           weight2 = weight2 * 0.453592;
        }
        
      }
      var lost_weight =  weight - weight2;
      var added_weight = weight2 - weight;
      lost_weight = Number(lost_weight.toFixed(2));
      added_weight = Number(added_weight.toFixed(2));

      // var anthropometryList = 
      // [
      //   age2,
      //   height,
      //   weight,
      //   lost_weight,
      //   added_weight,
      //   weight2
      // ]
      // setAnthropometryy(anthropometryList)

     
        var DietOrder2 = response.data.DietOrder2
        var DietOrder4 = response.data.DietOrder4
    
        if(User.calendar_type == 'ad')
        {
          var StartDateFa= DietOrder4.start_date_en
        }
        else
        {
          var StartDateFa= DietOrder4.start_date_fa
        }

        if(User.calendar_type == 'ad')
        {
          var StartDateFa2= DietOrder4 == null ? StartDateFa : DietOrder4.start_date_en
        }
        else
        {
          var StartDateFa2= DietOrder4 == null ? StartDateFa : DietOrder4.start_date_fa
        }



        var TypeOfDiet = DietOrder4.type_of_diet
        var number_weeks = DietOrder4.number_weeks
        var initial_number_weeks = DietOrder4.initial_number_weeks
        setTypeOfDiet(TypeOfDiet)
        setStartDateFa(StartDateFa)
        setStartDateFa2(StartDateFa2)
        const currentDateTime = moment()
        if(User.calendar_type == 'ad')
        {
          var anotherDate = moment(StartDateFa2, 'YYYY/MM/DD');
        }
        else
        {
          var anotherDate = moment(StartDateFa2, 'jYYYY/jMM/jDD');
        }



        const diffInDays = currentDateTime.diff(anotherDate, 'days');
        setDateDifference(Math.round(diffInDays/7));
        if(initial_number_weeks == 6)
        {
          if(number_weeks == 6)
          {
            setNameWeeks('اول')
          }
          else if(number_weeks == 5)
          {
            setNameWeeks('دوم')
          }
          else if(number_weeks == 4)
          {
            setNameWeeks('سوم')
          }
          else if(number_weeks == 3)
          {
            setNameWeeks('چهارم')
          }
          else if(number_weeks == 2)
          {
            setNameWeeks('پنجم')
          }
          else if(number_weeks == 1)
          {
            setNameWeeks('ششم')
          }
            

        }
        else if(initial_number_weeks == 12)
        {

          if(number_weeks == 12)
          {
            setNameWeeks('اول')
          }
          else if(number_weeks == 11)
          {
            setNameWeeks('دوم')
          }
          else if(number_weeks == 10)
          {
            setNameWeeks('سوم')
          }
          else if(number_weeks == 9)
          {
            setNameWeeks('چهارم')
          }
          else if(number_weeks == 8)
          {
            setNameWeeks('پنجم')
          }
          else if(number_weeks == 7)
          {
            setNameWeeks('ششم')
          }
          else if(number_weeks == 6)
          {
            setNameWeeks('هفتم')
          }
          else if(number_weeks == 5)
          {
            setNameWeeks('هشتم')
          }
          else if(number_weeks == 4)
          {
            setNameWeeks('نهم')
          }
          else if(number_weeks == 3)
          {
            setNameWeeks('دهم')
          }
          else if(number_weeks == 2)
          {
            setNameWeeks('یازدهم')
          }
          else if(number_weeks == 1)
          {
            setNameWeeks('دوازدهم')
          }
          

           
        }
        else if (initial_number_weeks == 26)
        {

          if(number_weeks == 26)
          {
            setNameWeeks('اول')
          }
          else if(number_weeks == 25)
          {
            setNameWeeks('دوم')
          }
          else if(number_weeks == 24)
          {
            setNameWeeks('سوم')
          }
          else if(number_weeks == 23)
          {
            setNameWeeks('چهارم')
          }
          else if(number_weeks == 22)
          {
            setNameWeeks('پنجم')
          }
          else if(number_weeks == 21)
          {
            setNameWeeks('ششم')
          }
          else if(number_weeks == 20)
          {
            setNameWeeks('هفتم')
          }
          else if(number_weeks == 19)
          {
            setNameWeeks('هشتم')
          }
          else if(number_weeks == 18)
          {
            setNameWeeks('نهم')
          }
          else if(number_weeks == 17)
          {
            setNameWeeks('دهم')
          }
          else if(number_weeks == 16)
          {
            setNameWeeks('یازدهم')
          }
          else if(number_weeks == 15)
          {
            setNameWeeks('دوازدهم')
          }
          else if(number_weeks == 14)
          {
            setNameWeeks('سیزدهم')
          }
          else if(number_weeks == 13)
          {
            setNameWeeks('چهاردهم')
          }
          else if(number_weeks == 12)
          {
            setNameWeeks('پانزدهم')
          }
          else if(number_weeks == 11)
          {
            setNameWeeks('شانزدهم')
          }
          else if(number_weeks == 10)
          {
            setNameWeeks('هفدهم')
          }
          else if(number_weeks == 9)
          {
            setNameWeeks('هجدهم')
          }
          else if(number_weeks == 8)
          {
            setNameWeeks('نوزدهم')
          }
          else if(number_weeks == 7)
          {
            setNameWeeks('بیستم')
          }
          else if(number_weeks == 6)
          {
            setNameWeeks('بیست یکم')
          }
          else if(number_weeks == 5)
          {
            setNameWeeks('بیست دوم')
          }
          else if(number_weeks == 4)
          {
            setNameWeeks('بیست سوم')
          }
          else if(number_weeks == 3)
          {
            setNameWeeks('بیست چهارم')
          }
          else if(number_weeks == 2)
          {
            setNameWeeks('بیست پنجم')
          }
          else if(number_weeks == 1)
          {
            setNameWeeks('بیست ششم')
          }


          

        }







        var Anthropometry3 = response.data.Anthropometry3
        var Anthropometry4 = response.data.Anthropometry4
        
        if(Anthropometry5.weight_kg != 0)
        {
           var weight_kg = Anthropometry5.weight_kg.split(" ");
            var weight_kg1 = weight_kg[0];
            var weight_kg2 = weight_kg[1];
            var result_weight =  parseFloat(weight_kg1 + '.' + weight_kg2)
           
           

        }
        else
        {
            var weight_po = Anthropometry5.weight_po.split(" ");
            var weight_po1 = weight_po[0];
            var weight_po2 = weight_po[1];
            var result_weight =  parseFloat(weight_po1 + '.' + weight_po2)
            var result_weight = result_weight * 0.45359237;
        }


        if(Anthropometry5.initial_weight_kg!= 0)
        {
           var initial_weight_kg = Anthropometry5.initial_weight_kg.split(" ");
            var weight_kg1 = initial_weight_kg[0];
            var weight_kg2 = initial_weight_kg[1];
            var result_initial_weight =  parseFloat(weight_kg1 + '.' + weight_kg2)
           
           

        }
        else
        {
            var initial_weight_po = Anthropometry5.initial_weight_po.split(" ");
            var weight_po1 = initial_weight_po[0];
            var weight_po2 = initial_weight_po[1];
            var result_initial_weight_po =  parseFloat(weight_po1 + '.' + weight_po2)
            var result_initial_weight = result_initial_weight_po * 0.45359237;
        }
        if(Anthropometry3 != null)
        {
         
          if(Anthropometry3.initial_weight_kg!= 0)
          {
             var initial_weight_kg = Anthropometry3.initial_weight_kg.split(" ");
              var weight_kg1 = initial_weight_kg[0];
              var weight_kg2 = initial_weight_kg[1];
              var result_initial_weight2 =  parseFloat(weight_kg1 + '.' + weight_kg2)
             
             
 
          }
          else
          {
              var initial_weight_po = Anthropometry3.initial_weight_po.split(" ");
              var weight_po1 = initial_weight_po[0];
              var weight_po2 = initial_weight_po[1];
              var result_initial_weight_po =  parseFloat(weight_po1 + '.' + weight_po2)
              var result_initial_weight2 = result_initial_weight_po * 0.45359237;
          }

        }

        if(Anthropometry4 != null)
        {
          if(Anthropometry4.weight_kg!= 0)
          {
             var weight_kg = Anthropometry4.weight_kg.split(" ");
              var weight_kg1 = weight_kg[0];
              var weight_kg2 = weight_kg[1];
              var result_weight2 =  parseFloat(weight_kg1 + '.' + weight_kg2)
             
             
 
          }
          else
          {
              var weight_po = Anthropometry4.weight_po.split(" ");
              var weight_po1 = weight_po[0];
              var weight_po2 = weight_po[1];
              var result_weight_po =  parseFloat(weight_po1 + '.' + weight_po2)
              var result_weight2 = result_weight_po * 0.45359237;
          }

        }







        if(Anthropometry5.height_ce != 0)
        {
           var height_ce = Anthropometry5.height_ce;
           

           var result_height = parseInt(height_ce, 10) / 100;
           var result_height2 = height_ce;
        }
        else
        {
           var height_in = Anthropometry5.height_in;
           const centimeterValue = height_in * 2.54;
           var result_height = parseInt(centimeterValue, 10) / 100;
           var result_height2 = centimeterValue;
        }





        var BMI = Math.round(result_weight /(result_height * result_height)) 
        var initial_BMI = Math.round(result_initial_weight /(result_height * result_height)) 
        var initial_BMI2 = Math.round(result_initial_weight2 /(result_height * result_height)) 
       
        const jalaliDate = Anthropometry5.date_birth_fa != 'null' ? Anthropometry5.date_birth_fa : Anthropometry5.date_birth_en;

 // تبدیل تاریخ شمسی به تاریخ میلادی

 if(Anthropometry5.date_birth_en != 'null' && Anthropometry5.date_birth_en != 'undefined')
 {

     var gregorianDate = moment(jalaliDate, "YYYY/MM/DD").format("YYYY-MM-DD");
 }
 else
 {
   var gregorianDate = moment(jalaliDate, "jYYYY/jMM/jDD").locale("en").format("YYYY-MM-DD");
 }
 
       
        // تبدیل تاریخ تولد به شی Date
        const birthdateDate = new Date(gregorianDate);
        
        // تاریخ فعلی
        const currentDate = new Date();
        
        // محاسبه تفاوت تاریخ فعلی و تاریخ تولد به میلی‌ثانیه
        const ageInMilliseconds = currentDate - birthdateDate;
        
        // تبدیل میلی‌ثانیه به سال
        const ageInYears = ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);
        
        // تقریب به دقیقه اعشار اعشار
        var age = Math.floor(ageInYears);
        

        if(Anthropometry5.gender == 'men')
        {
           var gender = 'مرد'
        }
        else
        {
           var gender = 'زن'
        }

        if(BMI >= 1 && BMI < 18.5) 
        {
           var weightStatus = 'کمبود وزن'
        }
       else if(BMI >= 18.5 && BMI < 25)
        {
           var weightStatus = 'نرمال'
        }
       else if(BMI >= 25 && BMI < 30)
        {
          
           var weightStatus = 'اضافه وزن'
        }
        else if(BMI >= 30 && BMI < 35)
        {
           var weightStatus = 'چاقی درجه 1'
        }
        else if(BMI >= 35)
        {
           var weightStatus = 'چاقی مفرط'
        }
        /*-----------------------------------------------------*/

        if(initial_BMI >= 1 && initial_BMI < 18.5) 
        {
           var initial_weightStatus = 'کمبود وزن'
        }
       else if(initial_BMI >= 18.5 && initial_BMI < 25)
        {
           var initial_weightStatus = 'نرمال'
        }
       else if(initial_BMI >= 25 && initial_BMI < 30)
        {
          
           var initial_weightStatus = 'اضافه وزن'
        }
        else if(initial_BMI >= 30 && initial_BMI < 35)
        {
           var initial_weightStatus = 'چاقی درجه 1'
        }
        else if(initial_BMI >= 35)
        {
           var initial_weightStatus = 'چاقی مفرط'
        }

        /*-----------------------------------------------------*/

        if(initial_BMI2 >= 1 && initial_BMI2 < 18.5) 
        {
           var initial_weightStatus2 = 'کمبود وزن'
        }
       else if(initial_BMI2 >= 18.5 && initial_BMI2 < 25)
        {
           var initial_weightStatus2 = 'نرمال'
        }
       else if(initial_BMI2 >= 25 && initial_BMI2 < 30)
        {
          
           var initial_weightStatus2 = 'اضافه وزن'
        }
        else if(initial_BMI2 >= 30 && initial_BMI2 < 35)
        {
           var initial_weightStatus2 = 'چاقی درجه 1'
        }
        else if(initial_BMI2 >= 35)
        {
           var initial_weightStatus2 = 'چاقی مفرط'
        }
        

        if(age >= 17 && age < 24)
        {
           var idealWeight = (21 * (result_height * result_height)).toFixed(2)//Overweight
           var idealWeight2 = Math.round(result_weight - idealWeight)
           var Underweight = null
           var Overweight = null
           var Normal = null
          if(idealWeight2 < 0)
          {
           Underweight = idealWeight2
           Underweight = Math.abs(idealWeight2)
          }
          else if(idealWeight2 > 0)
          {
           Overweight = idealWeight2
          }
          else if(idealWeight2 == 0)
          {
           Normal = idealWeight2
          }
           
          
        }
        else if(age >= 24 && age < 44)
        {
           var idealWeight = (24 * (result_height * result_height)).toFixed(2)//Overweight
           var idealWeight2 = Math.round(result_weight - idealWeight)
           var Underweight = null
           var Overweight = null
           var Normal = null
          if(idealWeight2 < 0)
          {
           Underweight = idealWeight2
           Underweight = Math.abs(idealWeight2)
          }
          else if(idealWeight2 > 0)
          {
           Overweight = idealWeight2
          }
          else if(idealWeight2 == 0)
          {
           Normal = idealWeight2
          }
          
          
        }
        else if(age >= 24 && age < 44)
        {
           var idealWeight = (25 * (result_height * result_height)).toFixed(2)//Overweight
           var idealWeight2 = Math.round(result_weight - idealWeight)
           var Underweight = null
           var Overweight = null
           var Normal = null
          if(idealWeight2 < 0)
          {
           Underweight = idealWeight2
           Underweight = Math.abs(idealWeight2)
          }
          else if(idealWeight2 > 0)
          {
           Overweight = idealWeight2
          }
          else if(idealWeight2 == 0)
          {
           Normal = idealWeight2
          }
        
          
        }
        else if( age >= 44)
        {
           var idealWeight = (27 * (result_height * result_height)).toFixed(2)//Overweight
           var idealWeight2 = Math.round(result_weight - idealWeight)
           var Underweight = null
           var Overweight = null
           var Normal = null
          if(idealWeight2 < 0)
          {
           Underweight = idealWeight2
           Underweight = Math.abs(idealWeight2)
          }
          else if(idealWeight2 > 0)
          {
           Overweight = idealWeight2
          }
          else if(idealWeight2 == 0)
          {
           Normal = idealWeight2
          }
         
          
        }

        var Weightrange = (18.5 * (result_height * result_height)).toFixed(2)
        var Weightrange2 = (24.99 * (result_height * result_height)).toFixed(2)
        var Skeleton = (result_height2 / Anthropometry5.around_wrist_ri).toFixed(1)
        

        if(Anthropometry5.gender == 'men')
        {
           if(Skeleton > 10.4)
           {
               var SkeletonText = 'کوچیک'
           }
           else if(Skeleton >= 9.6 && Skeleton <= 10.4)
           {
               var SkeletonText = 'متوسط'
           }
           else if(Skeleton < 9.6)
           {
               var SkeletonText = 'بزرگ'
           }
        }
        else
        {
           if(Skeleton > 11)
           {
               var SkeletonText = 'کوچیک'
           }
           else if(Skeleton >= 10.1 && Skeleton <= 11)
           {
               var SkeletonText = 'متوسط'
           }
           else if(Skeleton < 10.1)
           {
               var SkeletonText = 'بزرگ'
           }
        }
        var added_weight = result_weight - result_initial_weight2
        var added_weight_now = result_weight - result_initial_weight
      
        if(added_weight_now == 0 && result_weight2)
        {
         added_weight_now = result_initial_weight - result_weight2
        }

        if(added_weight < 0)
        {
         added_weight = 0
        }
        if(added_weight_now < 0)
        {
         added_weight_now = 0
        }

        var Weight_lost = result_initial_weight2 - result_weight  
        var Weight_lost_now = result_initial_weight - result_weight  
        if(Weight_lost_now == 0 && result_weight2)
        {
         Weight_lost_now = result_initial_weight - result_weight2  
        }

        if(Weight_lost < 0)
        {
         Weight_lost = 0
        }
        if(Weight_lost_now < 0)
        {
         Weight_lost_now = 0
        }



        









      if(DietOrder)
      {
        if(DietOrder.type_of_diet == 'increase')
        {
          var type_diet = 'رژیم افزایش'
        }
        else if(DietOrder.type_of_diet == 'decrease')
        {
          var type_diet = 'رژیم کاهش'
        }
        else
        {
          var type_diet = 'رژیم ثبات'
        }
      }
      else
      {
        var type_diet = null
      }

      if(DietMethod)
      {
        var dietmethod_text = DietMethod.dietmethod_text
      }
      else
      {
        var dietmethod_text = null
      }

      if(FoodMenu)
      {
        var foodmenu_text = FoodMenu.foodmenu_text
      }
      else
      {
        var foodmenu_text = null
      }

      if(Anthropometry5)
      {

        if(Anthropometry5.weight_kg != 0)
         {
            var weight_kg = Anthropometry5.weight_kg.split(" ");
             var weight_kg1 = weight_kg[0];
             var weight_kg2 = weight_kg[1];
             var result_weight =  parseFloat(weight_kg1 + '.' + weight_kg2)
            
            

         }
         else
         {
             var weight_po = Anthropometry5.weight_po.split(" ");
             var weight_po1 = weight_po[0];
             var weight_po2 = weight_po[1];
             var result_weight =  parseFloat(weight_po1 + '.' + weight_po2)
             var result_weight = result_weight * 0.45359237;
         }
         if(Anthropometry5.height_ce != 0)
         {
            var height_ce = Anthropometry5.height_ce;
            

            var result_height = parseInt(height_ce, 10) / 100;
            var result_height2 = height_ce;
         }
         else
         {
            var height_in = Anthropometry5.height_in;
            const centimeterValue = height_in * 2.54;
            var result_height = parseInt(centimeterValue, 10) / 100;
            var result_height2 = centimeterValue;
         }
         var BMI = Math.round(result_weight /(result_height * result_height)) 
         const jalaliDate = Anthropometry5.date_birth_fa != 'null' ? Anthropometry5.date_birth_fa : Anthropometry5.date_birth_en;

         // تبدیل تاریخ شمسی به تاریخ میلادی
       
         if(Anthropometry5.date_birth_en != 'null')
         {
       
             var gregorianDate = moment(jalaliDate, "YYYY/MM/DD").format("YYYY-MM-DD");
         }
         else
         {
           var gregorianDate = moment(jalaliDate, "jYYYY/jMM/jDD").locale("en").format("YYYY-MM-DD");
         }
         
               
                // تبدیل تاریخ تولد به شی Date
                const birthdateDate = new Date(gregorianDate);
                
                // تاریخ فعلی
                const currentDate = new Date();
                
                // محاسبه تفاوت تاریخ فعلی و تاریخ تولد به میلی‌ثانیه
                const ageInMilliseconds = currentDate - birthdateDate;
                
                // تبدیل میلی‌ثانیه به سال
                const ageInYears = ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);
                
                // تقریب به دقیقه اعشار اعشار
                var age = Math.floor(ageInYears);
                if(Anthropometry5.gender == 'men')
                {
                   var gender = 'مرد'
                }
                else
                {
                   var gender = 'زن'
                }
                var around_wrist_ri = Anthropometry5.around_wrist_ri
      }
      else
      {
        var result_weight = null
        var result_height = null
        var result_height2 = null
        var BMI = null
        var age = null
        var gender = null
        var around_wrist_ri = null

      }

      if(OutputInformation)
      {
        if(OutputInformation.weight_loss_diet_calories1 == 0 && OutputInformation.weight_loss_diet_calories2 == 0)
        {
          var total_calories = '('+OutputInformation.weight_loss_diet_calories+')'+' ' + 'kcal'
        }
        else
        {
          var total_calories = ' کالری1:' + ' ' +OutputInformation.weight_loss_diet_calories1 + ' ' + ' کالری2:' + ' ' +OutputInformation.weight_loss_diet_calories2
        }
      }
      else
      {
        var total_calories = null
      }

      setDietOrder({
        'type_diet' : type_diet,
        'dietmethod_text' : dietmethod_text,
        'foodmenu_text' : foodmenu_text,
        'total_calories' : total_calories
        
     });

         setAnthropometry({
          'weight' : result_weight,
            'height' : result_height,
            'height2' : result_height2,
            'bmi' : BMI,
            'initial_bmi' : initial_BMI,
            'initial_bmi2' : initial_BMI2,
            'age' : age,
            'gender' : gender,
            'around_wrist_ri' : Anthropometry5.around_wrist_ri,
            'weightStatus' : weightStatus,
            'initial_weightStatus' : initial_weightStatus,
            'initial_weightStatus2' : initial_weightStatus2,
            'idealWeight' : idealWeight,
            'Underweight' : Underweight,
            'Overweight' : Overweight,
            'Normal' : Normal,
            'Weightrange' : Weightrange,
            'Weightrange2' : Weightrange2,
            'SkeletonText' : SkeletonText,
            'result_initial_weight' : result_initial_weight,
            'result_initial_weight2' : result_initial_weight2,
            'result_weight2' : result_weight2,
            'added_weight' : added_weight,
            'added_weight_now' : added_weight_now,
            'Weight_lost' : Weight_lost,
            'Weight_lost_now' : Weight_lost_now
          
       });
       

     
    })
    .catch((error) => {
      console.error(error);
    });

    const rows = monthlyPicture; // برای مثال، داده‌های جدول

  
  },[]);
  // تغییر هفته انتخابی
  const handleWeekSelect = (weekIndex) => {
    setSelectedWeek(weekIndex);
    setIsDropdownOpen(false);
  };

  // تابع helper برای جستجوی یک فیلد در تمام index‌های آرایه
  const findFieldInArray = (parsedWeekInfo, fieldName) => {
    if (!Array.isArray(parsedWeekInfo)) return null;
    for (let i = 0; i < parsedWeekInfo.length; i++) {
      if (parsedWeekInfo[i] && 
          typeof parsedWeekInfo[i] === 'object' && 
          parsedWeekInfo[i][fieldName] && 
          parsedWeekInfo[i][fieldName] !== null && 
          parsedWeekInfo[i][fieldName] !== 'null' &&
          parsedWeekInfo[i][fieldName] !== '') {
        return parsedWeekInfo[i][fieldName];
      }
    }
    return null;
  };

  // تبدیل رشته JSON در فیلد "questions" به آبجکت و گرفتن بیماری‌ها
  const getDiseasesFromQuestions = (questionsString) => {
    try {
      const questions = JSON.parse(questionsString);
      const activeDiseases = [];
  
      // نگاشت کلیدهای option به نام بیماری‌ها (مطابق با لیست سوالات)
      const diseaseMapping = {
        option1: "بیماری کبد چرب",
        option2: "سردرد های میگرنی",
        option3: "بیماری آرتروز",
        option4: "ریزش مو",
        option5: "فشار خون بالا",
        option6: "بیماری صرع",
        option7: "رفلاکس معده",
        option8: "بیماری MS",
        option9: "غلظت خون بالا",
        option10: "سندرم روده تحریک پذیر",
        option11: "داروهای کورتون دار",
        option12: "بیماری نقرس",
        option13: "جراحی برداشت کیسه صفرا",
        option14: "بیماری آرتریت روماتوئید",
        option15: "عفونت معده خفیف",
        option16: "یبوست",
        option17: "چربی خون بالا",
        option18: "بیماری کولیت",
        option19: "پر کاری تیروئید",
        option20: "بیماری افسردگی خفیف",
        option21: "کم خونی",
        option22: "مشروبات الکی",
        option23: "سنگ کلیه",
        option24: "هرمون درمانی",
        option25: "کم کاری تیروئید",
        option26: "پوکی استخوان",
      };
  
      // بررسی برای هر option و اضافه کردن گزینه‌هایی که true هستند (26 سوال)
      for (let i = 1; i <= 26; i++) {
        const optionKey = `option${i}`;
        if (questions[optionKey] === "true" && diseaseMapping[optionKey]) {
          activeDiseases.push(diseaseMapping[optionKey]);
        }
      }
  
      // بررسی و اضافه کردن special_disease اگر موجود باشد و خالی نباشد
      if (questions.special_disease && 
          typeof questions.special_disease === 'string' &&
          questions.special_disease.trim() !== '' && 
          questions.special_disease !== 'null') {
        activeDiseases.push(questions.special_disease);
      }
  
      return activeDiseases;
    } catch (error) {
      console.error("Error parsing questions:", error);
      return [];
    }
  };
  
  

  const chartRef = useRef(null); // استفاده از useRef برای دسترسی به چارت
  if(weightsSession !== null)
  {

    var date_chart = weightsSession.map(item => item.date_en);
    var Weight_chart = weightsSession.map(item => 
      
      {
        const weight_kg = item.w_kg.split(" ");
             const weight_kg1 = weight_kg[0];
             const weight_kg2 = weight_kg[1];
             const result_weight =  parseFloat(weight_kg1 + '.' + weight_kg2)
      return result_weight
      });
  
  }
  else
  {
    var date_chart = 0 
    var Weight_chart = 0 
  }
  const weightData = Weight_chart; // مقادیر وزنی
const labels = date_chart; // بازه‌های زمانی (تاریخ‌ها)

// پیکربندی داده‌های نمودار
const data = {
  labels: labels, // لیست تاریخ‌ها یا بازه‌های زمانی
  datasets: [
    {
      label: 'روند تغیرات وزن در طول زمان',
      data: weightData, // داده‌های وزنی
      // borderColor: 'rgba(75, 192, 192, 1)', // رنگ خط نمودار
      // backgroundColor: 'rgba(75, 192, 192, 0.2)', // رنگ پس‌زمینه زیر نمودار
      fill: true, // پر کردن زیر خط نمودار
      tension: 0.4, // منحنی نرم
      backgroundColor: 'rgb(114, 226, 33)', // رنگ میله‌ها (نیمه‌شفاف)
      borderColor: 'linear-gradient(45deg, rgb(153, 218, 67), rgb(114, 226, 33))', // رنگ حاشیه میله‌ها
      borderWidth: 1,
      barThickness: 50
      
      
    },
  ],
};

// تنظیمات نمودار
const options = {
  responsive: true,
  plugins: {
      legend: {
        
          display: false,
          labels: {
           
            font: {
              size: 14, // اندازه فونت لیبل
              family: 'Dana', // نوع فونت
              style: 'normal', // استایل فونت
              weight: 'bold', // وزن فونت
              color:'red'
            },
          },
         
      },
      title: {
          display: true,
         
      },
      datalabels: {
        anchor: 'end',
        align: 'end',
        formatter: (value) => `${value}kg`,
        color:'red',
        font: {
          size: 10,  // اندازه فونت دیتالبل‌ها
          family: 'Dana',  // نوع فونت دیتالبل‌ها
         
          weight: 'bold',  // وزن فونت دیتالبل‌ها (مثلاً normal, bold)
        },
      },
  },
  scales: {
      x: {
          ticks: {
              maxRotation: 90, // حداکثر چرخش برچسب‌های محور X
              minRotation: 45, // حداقل چرخش برچسب‌ها
          },
          title: {
            display: true,
            text: '    زمان'    ,
            padding: {
              
              right: 30  // تنظیم فاصله از راست یا چپ
            },
            align: 'end', // امتحان کنید تا تغییر را ببینید
            font: {
              size: 13,  // اندازه فونت
              family: 'Dana',  // نوع فونت
              style: 'normal',  // استایل فونت
              weight: 'bold',  // وزن فونت
            },
          },
      },
      y: {
        
          beginAtZero: true, // شروع محور y از صفر
          title: {
            display: true,
            text: 'وزن (کیلوگرم)',
            padding: {
              top: 30,  // تنظیم فاصله از بالای محور
              bottom: 10,
            },
            align: 'end', 
            font: {
              size: 13,  // اندازه فونت
              family: 'Dana',  // نوع فونت
              style: 'normal',  // استایل فونت
              weight: 'bold',  // وزن فونت
            },
            rotation: 0,
          },
      },
  },


};

const downloadChart = () => {
  const chartElement = chartRef.current; // گرفتن مرجع به نمودار
  if (chartElement) {
    html2canvas(chartElement.canvas, { scale: 3 }).then((canvas) => {
      const url = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = url;
      link.download = 'chart.png'; // نام فایل دانلودی
      link.click(); // کلیک خودکار برای شروع دانلود
    });
  }
};

const loginToAccount = (userId,app_type) => {
  const formData = new FormData();
  formData.append('userId', userId);

  axios.post(serverUrl + "login-user-account", formData)
    .then(response => {
      if (response.data.success) {
        const apiToken = response.data.api_token;
        
        // برای کاربران مشاوره (sub_app)، به پروژه aryadiet-second-main هدایت کن
        if (app_type === 'sub_app') {
          const redirectUrl = `https://appointment.aryadiet.com/admin-login/${apiToken}`;
          window.location.href = redirectUrl;
        } else {
          // برای کاربران رژیم، به پروژه قبلی هدایت کن
          const redirectUrl = `https://diett.aryadiet.com/regime/admin-login/${apiToken}`;
          window.location.href = redirectUrl;
        }
      } 
    
       else {
        // در صورت وجود خطا، پیام مناسب نمایش داده می‌شود
        alert("خطا!", "ورود به اکانت با مشکل مواجه شد.", "error");
      }
    })
    .catch(error => {
      console.error("خطا در ارسال درخواست: ", error);
      alert('خطا!', 'ارتباط با سرور برقرار نشد.', 'error');
    });
};
  return (
    <>
     <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <h5 style={{textAlign:'right'}} className="title">اطلاعات کاربر</h5>
                
              </CardHeader>
              <CardBody className="user-info">
                <div className="profile-user">
                  <div>
                  <img src={user.profile ?  user.profile : 'https://www.w3schools.com/howto/img_avatar.png'} alt="" srcset="" />
                  </div>
                  <p>{(user.name != null && user.name != 'null') ? user.name : 'پروفایل کاربر'}</p>
                </div>

           {/* سلکت باکس انتخاب هفته */}
           <h3 style={{ textAlign: "center", marginBottom: "20px"}}>
        نمایش اطلاعات هفته‌ها
      </h3>
           <div style={tableStyles.container}>
     
           <Table hover responsive>
  <thead>
    <tr style={tableStyles.headerRow}>
      <th style={tableStyles.cell}>هفته</th>
      <th style={tableStyles.cell}>تاریخ</th>
      <th style={tableStyles.cell}>متابولیسم</th>
      <th style={tableStyles.cell}>فعالیت روزانه</th>
      <th style={tableStyles.cell}>روش رژیم غذایی</th>
      <th style={tableStyles.cell}>منوی رژیم غذایی</th>
      <th style={tableStyles.cell}>نوع رژیم غذایی</th>
      <th style={tableStyles.cell}>کالری کل</th>
      <th style={tableStyles.cell}>بیماری‌ها</th>
    </tr>
  </thead>
  <tbody>
  {Array.isArray(weeklyInformation) && weeklyInformation.length > 0 ? (() => {
  let cumulativeWeekNumber = 1; // شمارنده‌ی تجمعی برای شماره هفته‌ها

  return weeklyInformation.flatMap((weekArray, weekIndex) =>
    weekArray.map((weekData, recordIndex) => {
      let parsedWeekInfo = [];
      // استفاده از dietOrder.dietmethod_text به عنوان مقدار پیش‌فرض
      let dietMethodText = dietOrder?.dietmethod_text || "ثبت نشده";
      let typeOfDietText = dietOrder?.type_diet || "ثبت نشده"; // خواندن از dietOrder state

      let questionsString = "{}"; // مقدار پیش‌فرض برای questions

      try {
        // پارس JSON string به آرایه
        parsedWeekInfo = JSON.parse(weekData);
        
        // Parse کردن dietMethod که خودش یک JSON string است
        // بررسی در تمام index ها برای dietMethod با استفاده از findFieldInArray
        const dietMethodValue = findFieldInArray(parsedWeekInfo, 'dietMethod');
        if (dietMethodValue) {
          try {
            const dietMethodObj = JSON.parse(dietMethodValue);
            dietMethodText = dietMethodObj?.dietmethod_text || dietOrder?.dietmethod_text || "ثبت نشده";
          } catch (e) {
            // اگر dietMethod یک string ساده باشد، مستقیماً استفاده کن
            if (typeof dietMethodValue === 'string' && !dietMethodValue.startsWith('{')) {
              dietMethodText = dietMethodValue;
            } else {
              // اگر parse نشد، از dietOrder استفاده کن
              dietMethodText = dietOrder?.dietmethod_text || "ثبت نشده";
              console.error("خطا در پارس کردن dietMethod:", e);
            }
          }
        } else if (parsedWeekInfo?.[2]?.dietMethod) {
          // Fallback به روش قدیمی
          try {
            const dietMethodObj = JSON.parse(parsedWeekInfo[2].dietMethod);
            dietMethodText = dietMethodObj?.dietmethod_text || dietOrder?.dietmethod_text || "ثبت نشده";
          } catch (e) {
            if (typeof parsedWeekInfo[2].dietMethod === 'string') {
              dietMethodText = parsedWeekInfo[2].dietMethod;
            } else {
              dietMethodText = dietOrder?.dietmethod_text || "ثبت نشده";
              console.error("خطا در پارس کردن dietMethod:", e);
            }
          }
        }

        // بررسی وجود questions در تمام index ها
        const questionsValue = findFieldInArray(parsedWeekInfo, 'questions');
        if (questionsValue) {
          questionsString = questionsValue;
        } else {
          // Fallback به روش قدیمی
          if (parsedWeekInfo?.[3]?.questions) {
            questionsString = parsedWeekInfo[3].questions;
          } else if (parsedWeekInfo?.[4]?.questions) {
            questionsString = parsedWeekInfo[4].questions;
          } else if (parsedWeekInfo?.[6]?.questions) {
            questionsString = parsedWeekInfo[6].questions;
          }
        }
      } catch (error) {
        console.error("خطا در پارس کردن JSON:", error);
        parsedWeekInfo = [];
      }

      // ذخیره شماره هفته فعلی و سپس افزایش مقدار برای رکورد بعدی
      const currentWeekNumber = cumulativeWeekNumber++;
      
      // استفاده از findFieldInArray برای فیلدهای دیگر
      const dateValue = findFieldInArray(parsedWeekInfo, 'date') || parsedWeekInfo?.[6]?.date || parsedWeekInfo?.[5]?.date || parsedWeekInfo?.[4]?.date || null;
      const foodMenuValue = findFieldInArray(parsedWeekInfo, 'foodMenu') || parsedWeekInfo?.[2]?.foodMenu || parsedWeekInfo?.[3]?.foodMenu || null;
      const caloriesValue = findFieldInArray(parsedWeekInfo, 'weight_loss_diet_calories') || parsedWeekInfo?.[5]?.weight_loss_diet_calories || parsedWeekInfo?.[4]?.weight_loss_diet_calories || parsedWeekInfo?.[3]?.weight_loss_diet_calories || null;
      
      return (
        <tr key={`${weekIndex}-${recordIndex}`} style={tableStyles.hoverRow}>
          <td style={tableStyles.cell}>{`هفته ${currentWeekNumber}`}</td>
          <td style={tableStyles.cell}>
            {dateValue || "ثبت نشده"}
          </td>
          <td style={tableStyles.cell}>
            {findFieldInArray(parsedWeekInfo, 'conditionsText') || conditions?.conditions_text || "ثبت نشده"}
          </td>
          <td style={tableStyles.cell}>
            {findFieldInArray(parsedWeekInfo, 'activityText') || dailyActivity?.activity_text || "ثبت نشده"}
          </td>
          <td style={tableStyles.cell}>
            {dietMethodText}
          </td>
          <td style={tableStyles.cell}>
            {foodMenuValue || "ثبت نشده"}
          </td>
          <td style={tableStyles.cell}>
            {typeOfDietText}
          </td>
          <td style={tableStyles.cell}>
            {caloriesValue || "ثبت نشده"}
          </td>
          <td style={tableStyles.cell}>
            <div style={diseaseContainerStyles}>
              {getDiseasesFromQuestions(questionsString).map(
                (disease, i) => (
                  <div key={i} style={diseaseBoxStyles}>
                    {disease}
                  </div>
                )
              )}
            </div>
          </td>
        </tr>
      );
    })
  );
})() : (
  <tr>
    <td colSpan="9" style={{ textAlign: "center", padding: "10px" }}>
      هیچ اطلاعاتی موجود نیست
    </td>
  </tr>
)}

</tbody>




</Table>


    </div>

{/* نمایش اطلاعات هفته */}
{selectedWeek !== null && (
  <div className="week-details">
    <h4>{`اطلاعات هفته ${selectedWeek + 1}`}</h4>
    <div className="week-info">
    <div className="info-box">
        <strong>تاریخ:</strong>
        <p style={{color:'#333',marginRight:'3px'}}>
          {(() => {
            try {
              const weekArray = weeklyInformation[selectedWeek];
              if (Array.isArray(weekArray) && weekArray.length > 0) {
                for (let i = 0; i < weekArray.length; i++) {
                  try {
                    if (typeof weekArray[i] === 'string') {
                      const parsedWeekInfo = JSON.parse(weekArray[i]);
                      const dateValue = findFieldInArray(parsedWeekInfo, 'date');
                      if (dateValue) {
                        return dateValue;
                      }
                    }
                  } catch (parseError) {
                    continue;
                  }
                }
              }
              return weeklyInformation[selectedWeek]?.[6]?.date || weeklyInformation[selectedWeek]?.[7]?.date || weeklyInformation[selectedWeek]?.[5]?.date || weeklyInformation[selectedWeek]?.[4]?.date || "ثبت نشده";
            } catch (e) {
              return weeklyInformation[selectedWeek]?.[6]?.date || weeklyInformation[selectedWeek]?.[7]?.date || "ثبت نشده";
            }
          })()}
        </p>
      </div>
      <div className="info-box">
        <strong>متابولیسم:</strong>
        <p style={{color:'#333',marginRight:'3px'}}>
          {(() => {
            try {
              const weekArray = weeklyInformation[selectedWeek];
              if (Array.isArray(weekArray) && weekArray.length > 0) {
                // بررسی تمام عناصر آرایه هفته
                for (let i = 0; i < weekArray.length; i++) {
                  try {
                    if (typeof weekArray[i] === 'string') {
                      const parsedWeekInfo = JSON.parse(weekArray[i]);
                      const conditionsText = findFieldInArray(parsedWeekInfo, 'conditionsText');
                      if (conditionsText) {
                        return conditionsText;
                      }
                    }
                  } catch (parseError) {
                    // اگر parse نشد، به عنصر بعدی برو
                    continue;
                  }
                }
              }
              // اگر در weekly_information پیدا نشد، از Conditions استفاده کن
              return conditions?.conditions_text || "ثبت نشده";
            } catch (e) {
              return conditions?.conditions_text || "ثبت نشده";
            }
          })()}
        </p>
      </div>
      <div className="info-box">
        <strong>فعالیت روزانه:</strong>
        <p style={{color:'#333',marginRight:'3px'}}>
          {(() => {
            try {
              const weekArray = weeklyInformation[selectedWeek];
              if (Array.isArray(weekArray) && weekArray.length > 0) {
                // بررسی تمام عناصر آرایه هفته
                for (let i = 0; i < weekArray.length; i++) {
                  try {
                    if (typeof weekArray[i] === 'string') {
                      const parsedWeekInfo = JSON.parse(weekArray[i]);
                      const activityText = findFieldInArray(parsedWeekInfo, 'activityText');
                      if (activityText) {
                        return activityText;
                      }
                    }
                  } catch (parseError) {
                    // اگر parse نشد، به عنصر بعدی برو
                    continue;
                  }
                }
              }
              // اگر در weekly_information پیدا نشد، از DailyActivity استفاده کن
              return dailyActivity?.activity_text || "ثبت نشده";
            } catch (e) {
              return dailyActivity?.activity_text || "ثبت نشده";
            }
          })()}
        </p>
      </div>
      <div className="info-box">
        <strong>روش رژیم غذایی:</strong>
        <p style={{color:'#333',marginRight:'3px'}}>
          {(() => {
            try {
              const weekArray = weeklyInformation[selectedWeek];
              if (Array.isArray(weekArray) && weekArray.length > 0) {
                for (let i = 0; i < weekArray.length; i++) {
                  try {
                    if (typeof weekArray[i] === 'string') {
                      const parsedWeekInfo = JSON.parse(weekArray[i]);
                      const dietMethodValue = findFieldInArray(parsedWeekInfo, 'dietMethod');
                      if (dietMethodValue) {
                        try {
                          const dietMethodObj = JSON.parse(dietMethodValue);
                          return dietMethodObj?.dietmethod_text || "ثبت نشده";
                        } catch (e) {
                          return dietMethodValue;
                        }
                      }
                    }
                  } catch (parseError) {
                    continue;
                  }
                }
              }
              return dietOrder?.dietmethod_text || weeklyInformation[selectedWeek]?.[2]?.dietMethod || "ثبت نشده";
            } catch (e) {
              return dietOrder?.dietmethod_text || "ثبت نشده";
            }
          })()}
        </p>
      </div>
      <div className="info-box">
        <strong>منوی رژیم غذایی:</strong>
        <p style={{color:'#333',marginRight:'3px'}}>
          {(() => {
            try {
              const weekArray = weeklyInformation[selectedWeek];
              if (Array.isArray(weekArray) && weekArray.length > 0) {
                for (let i = 0; i < weekArray.length; i++) {
                  try {
                    if (typeof weekArray[i] === 'string') {
                      const parsedWeekInfo = JSON.parse(weekArray[i]);
                      const foodMenuValue = findFieldInArray(parsedWeekInfo, 'foodMenu');
                      if (foodMenuValue) {
                        return foodMenuValue;
                      }
                    }
                  } catch (parseError) {
                    continue;
                  }
                }
              }
              return weeklyInformation[selectedWeek]?.[3]?.foodMenu || weeklyInformation[selectedWeek]?.[2]?.foodMenu || "ثبت نشده";
            } catch (e) {
              return "ثبت نشده";
            }
          })()}
        </p>
      </div>
      <div className="info-box">
        <strong>نوع رژیم غذایی:</strong>
        <p style={{color:'#333',marginRight:'3px'}}>{dietOrder?.type_diet || weeklyInformation[selectedWeek]?.[5]?.type_of_diet || "ثبت نشده"}</p>
      </div>
      <div className="info-box">
        <strong>کالری کل:</strong>
        <p style={{color:'#333',marginRight:'3px'}}>
          {(() => {
            try {
              const weekArray = weeklyInformation[selectedWeek];
              if (Array.isArray(weekArray) && weekArray.length > 0) {
                for (let i = 0; i < weekArray.length; i++) {
                  try {
                    if (typeof weekArray[i] === 'string') {
                      const parsedWeekInfo = JSON.parse(weekArray[i]);
                      const caloriesValue = findFieldInArray(parsedWeekInfo, 'weight_loss_diet_calories');
                      if (caloriesValue) {
                        return caloriesValue;
                      }
                    }
                  } catch (parseError) {
                    continue;
                  }
                }
              }
              return weeklyInformation[selectedWeek]?.[5]?.weight_loss_diet_calories || weeklyInformation[selectedWeek]?.[6]?.weight_loss_diet_calories || weeklyInformation[selectedWeek]?.[4]?.weight_loss_diet_calories || weeklyInformation[selectedWeek]?.[3]?.weight_loss_diet_calories || "ثبت نشده";
            } catch (e) {
              return "ثبت نشده";
            }
          })()}
        </p>
      </div>

      {/* نمایش بیماری‌ها */}
<div className="info-box">
  <strong>بیماری‌ها:</strong>
  <div style={diseaseContainerStyles}>
    {(() => {
      try {
        const weekArray = weeklyInformation[selectedWeek];
        let questionsString = "{}";
        if (Array.isArray(weekArray) && weekArray.length > 0) {
          for (let i = 0; i < weekArray.length; i++) {
            try {
              if (typeof weekArray[i] === 'string') {
                const parsedWeekInfo = JSON.parse(weekArray[i]);
                const questionsValue = findFieldInArray(parsedWeekInfo, 'questions');
                if (questionsValue) {
                  questionsString = questionsValue;
                  break;
                }
              }
            } catch (parseError) {
              continue;
            }
          }
        }
        if (questionsString === "{}") {
          questionsString = weeklyInformation[selectedWeek]?.[4]?.questions || weeklyInformation[selectedWeek]?.[3]?.questions || "{}";
        }
        return getDiseasesFromQuestions(questionsString).map((disease, index) => (
          <div key={index} style={diseaseBoxStyles}>
            {disease}
          </div>
        ));
      } catch (e) {
        return getDiseasesFromQuestions(weeklyInformation[selectedWeek]?.[4]?.questions || "{}").map((disease, index) => (
          <div key={index} style={diseaseBoxStyles}>
            {disease}
          </div>
        ));
      }
    })()}
  </div>
</div>

    </div>
  </div>
)}
<div style={{display:'flex' , justifyContent:'right',margin:'10px 0'}}>
<Link 
                              to="/rtl/rtl-edit-user-info" 
                              state={{ userid: user.id }}
                              className="btn btn-outline-primary btn-sm" // کلاس‌های بوت‌استرپ برای استایل دکمه
                              style={{ color: 'white' }} // رنگ متن برای تطابق با رنگ دکمه
                            >
                              ویرایش
                            </Link>
                            <button
                              onClick={() => loginToAccount(user.id,user.app_type)} 
                              className="btn btn-primary btn-sm"
                              style={{
                                backgroundColor: '#007bff',  
                                border: 'none',  
                                color: 'white',  
                                padding: '8px 15px',  
                                borderRadius: '5px', 
                                cursor: 'pointer',  
                                textAlign: 'center', 
                                marginRight:'10px' 
                              }}
                            >
                              ورود به اکانت
                            </button>
</div>

  <h3 style={{ textAlign: "center", marginBottom: "20px" }}>نظرات مشاوره‌های اتمام‌یافته</h3>
<div style={tableStyles.container}>
  <Table hover responsive>
    <thead>
      <tr style={tableStyles.headerRow}>
        <th style={tableStyles.cell}>تاریخ مشاوره</th>
        <th style={tableStyles.cell}>ساعت مشاوره</th>
        <th style={tableStyles.cell}>امتیاز</th>
        <th style={tableStyles.cell}>نظر</th>
      </tr>
    </thead>
    <tbody>
      {userSurveys.length > 0 ? (
        userSurveys.map((survey, index) => (
          <tr key={index} style={tableStyles.hoverRow}>
            <td style={tableStyles.cell}>{survey.reservation_date || "ثبت نشده"}</td>
            <td style={tableStyles.cell}>{survey.reservation_time || "ثبت نشده"}</td>
            <td style={tableStyles.cell}>{survey.rating || "ثبت نشده"}</td>
            <td style={tableStyles.cell}>{survey.comment || "بدون نظر"}</td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="4" style={{ textAlign: "center", padding: "10px" }}>
            هیچ نظری موجود نیست
          </td>
        </tr>
      )}
    </tbody>
  </Table>
</div>


{questionnaireData && (
  <div className="dark-compact-management">
    <div className="dark-compact-header">
      <h2 className="dark-compact-title">پرسشنامه تغذیه‌ای کاربران</h2>
      <button 
        className="dark-excel-btn"
        //onClick={() => exportToExcel(questionnaireData)}
      >
        دریافت اکسل
      </button>
    </div>
    
    <div className="dark-compact-grid">
      {/* ردیف 1 */}
      <div className="dark-compact-row">
        <div className="dark-compact-cell">
          <div className="dark-compact-question">1. تعداد وعده‌های صرف غذا</div>
          <div className="dark-compact-answer">{questionnaireData.answers[0] || 'ثبت نشده'}</div>
        </div>
        
        <div className="dark-compact-cell">
          <div className="dark-compact-question">2. ساعت مصرف وعده های غذایی</div>
          <div className="dark-sub-answers">
            <div><span>صبحانه:</span> {questionnaireData.mealTimes?.breakfast || 'ثبت نشده'}</div>
            <div><span>ناهار:</span> {questionnaireData.mealTimes?.lunch || 'ثبت نشده'}</div>
            <div><span>شام:</span> {questionnaireData.mealTimes?.dinner || 'ثبت نشده'}</div>
          </div>
        </div>
      </div>
      
      {/* ردیف 2 */}
      <div className="dark-compact-row">
        <div className="dark-compact-cell">
          <div className="dark-compact-question">3. کدام وعده مفصل تر است</div>
          <div className="dark-compact-answer">{questionnaireData.answers[2] || 'ثبت نشده'}</div>
        </div>
        
        <div className="dark-compact-cell">
          <div className="dark-compact-question">4. مدت زمان صرف غذا در هر وعده</div>
          <div className="dark-compact-answer">{questionnaireData.answers[3] || 'ثبت نشده'}</div>
        </div>
      </div>
      
      {/* ردیف 3 */}
      <div className="dark-compact-row">
        <div className="dark-compact-cell">
          <div className="dark-compact-question">5. فاصله شام و خواب چقدر است</div>
          <div className="dark-compact-answer">{questionnaireData.answers[4] || 'ثبت نشده'}</div>
        </div>
        
        <div className="dark-compact-cell">
          <div className="dark-compact-question">6. مقدار و نوع نوشیدنی در هنگام صرف غذا</div>
          <div className="dark-compact-answer">{questionnaireData.answers[5] || 'ثبت نشده'}</div>
        </div>
      </div>
      
      {/* ردیف 4 */}
      <div className="dark-compact-row">
        <div className="dark-compact-cell">
          <div className="dark-compact-question">7. میان وعده از چه غذاهایی استفاده میکنید</div>
          <div className="dark-compact-answer">{questionnaireData.answers[6] || 'ثبت نشده'}</div>
        </div>

        <div className="dark-compact-cell">
          <div className="dark-compact-question">8. غذای مورد علاقه</div>
          <div className="dark-compact-answer">{questionnaireData.answers[7] || 'ثبت نشده'}</div>
        </div>
      </div>
      
      {/* ردیف 5 */}
      <div className="dark-compact-row">
        <div className="dark-compact-cell">
          <div className="dark-compact-question">9. غذای ناخوشایند</div>
          <div className="dark-compact-answer">{questionnaireData.answers[8] || 'ثبت نشده'}</div>
        </div>
        
        <div className="dark-compact-cell">
          <div className="dark-compact-question">10. غذای اصلی خانواده</div>
          <div className="dark-compact-answer">{questionnaireData.answers[9] || 'ثبت نشده'}</div>
        </div>
      </div>
      
      {/* ردیف 6 */}
      <div className="dark-compact-row">
        <div className="dark-compact-cell">
          <div className="dark-compact-question">11. تعداد وعده مصرف ماهی در هفته</div>
          <div className="dark-compact-answer">{questionnaireData.answers[10] || 'ثبت نشده'}</div>
        </div>
        
        <div className="dark-compact-cell">
          <div className="dark-compact-question">12. تعداد وعده مصرف  در هفته</div>
          <div className="dark-sub-answers">
            <div><span>مرغ:</span> {questionnaireData.meatConsumption?.chicken || 'ثبت نشده'}</div>
            <div><span>قرمز:</span> {questionnaireData.meatConsumption?.redMeat || 'ثبت نشده'}</div>
          </div>
        </div>
      </div>
      
      {/* ردیف 7 */}
      <div className="dark-compact-row">
        <div className="dark-compact-cell">
          <div className="dark-compact-question">13. مصرف تخم‌مرغ در هفته</div>
          <div className="dark-compact-answer">{questionnaireData.answers[12] || 'ثبت نشده'}</div>
        </div>
        
        <div className="dark-compact-cell">
          <div className="dark-compact-question">14. مقدار مصرف شیر و لبنیات در روز</div>
          <div className="dark-compact-answer">{questionnaireData.answers[13] || 'ثبت نشده'}</div>
        </div>
      </div>
      
      {/* ردیف 8 */}
      <div className="dark-compact-row">
        <div className="dark-compact-cell">
          <div className="dark-compact-question">15. مقدار مصرف میوه و سبزیجات در روز</div>
          <div className="dark-compact-answer">{questionnaireData.answers[14] || 'ثبت نشده'}</div>
        </div>
        
        <div className="dark-compact-cell">
          <div className="dark-compact-question">16. میزان اشتها</div>
          <div className="dark-compact-answer">{questionnaireData.answers[15] || 'ثبت نشده'}</div>
        </div>
      </div>
      
      {/* ردیف 9 */}
      <div className="dark-compact-row">
        <div className="dark-compact-cell">
          <div className="dark-compact-question">17. میزان ورزش در هفته</div>
          <div className="dark-compact-answer">{questionnaireData.answers[16] || 'ثبت نشده'}</div>
        </div>
        
        <div className="dark-compact-cell">
          <div className="dark-compact-question">18. میزان مصرف نمک</div>
          <div className="dark-compact-answer">{questionnaireData.answers[17] || 'ثبت نشده'}</div>
        </div>
      </div>
    </div>

    <style jsx>{`
      .dark-compact-management {
        padding: 16px;
        font-family: 'Dana', sans-serif;
        background-color: #2181f7;
        border-radius: 8px;
        max-width: 1200px;
        margin: 0 auto;
        direction: rtl;
      }
      
      .dark-compact-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
      }
      
      .dark-compact-title {
        color: #1a202c;
        font-size: 1.3rem;
        font-weight: 600;
        margin: 0;
      }
      
      .dark-excel-btn {
        padding: 8px 16px;
        background-color: #2d3748;
        color: white;
        border: none;
        border-radius: 6px;
        cursor: pointer;
        font-size: 0.9rem;
        transition: background-color 0.2s;
      }
      
      .dark-excel-btn:hover {
        background-color: #4a5568;
      }
      
      .dark-compact-grid {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
      
      .dark-compact-row {
        display: flex;
        gap: 12px;
        width: 100%;
      }
      
      .dark-compact-cell {
        flex: 1;
        background-color: #ffffff;
        border-radius: 6px;
        padding: 12px;
        border: 1px solid #e2e8f0;
        box-shadow: 0 1px 2px rgba(0,0,0,0.05);
      }
      
      .dark-compact-question {
        color: #2d3748;
        font-weight: 500;
        font-size: 0.9rem;
        margin-bottom: 6px;
        text-align: right;
      }
      
      .dark-compact-answer {
        color: #4a5568;
        font-size: 0.95rem;
        line-height: 1.4;
        text-align: right;
      }
      
      .dark-sub-answers {
        display: flex;
        flex-direction: column;
        gap: 4px;
        text-align: right;
      }
      
      .dark-sub-answers div {
        display: flex;
        justify-content: space-between;
      }
      
      .dark-sub-answers span {
        color: #718096;
        margin-left: 8px;
      }
      
      @media (max-width: 768px) {
        .dark-compact-row {
          flex-direction: column;
        }
        
        .dark-compact-header {
          flex-direction: column;
          align-items: flex-start;
          gap: 12px;
        }
        
        .dark-excel-btn {
          width: 100%;
        }
      }
    `}</style>
  </div>
)}
                           
                <h3 style={{textAlign:'right'}}>اطلاعات فردی</h3>
                <Row>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">نام:</span>
                      <span className="info-value">{(user.name != null && user.name != 'null')  ? user.name : 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">نام خانوادگی:</span>
                      <span className="info-value">{(user.last_name != null && user.last_name != 'null')  ? user.last_name : 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">شماره تلفن:</span>
                      <span className="info-value">{(user.phone_number != null && user.phone_number != 'null')  ? user.phone_number : 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">ایمیل:</span>
                      <span className="info-value">{user.email}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">آدرس:</span>
                      <span className="info-value">{(user.address != null && user.address != 'null')  ? user.address : 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">شماره واتساپ:</span>
                      <span className="info-value">{(user.what_number != null && user.what_number != 'null')  ? user.what_number : 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">آیدی اسکایپ:</span>
                      <span className="info-value">{(user.skyp_id != null && user.skyp_id != 'null')  ? user.skyp_id : 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">کد پستی:</span>
                      <span className="info-value">{(user.postal_code != null && user.postal_code != 'null')  ? user.postal_code : 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">کشور:</span>
                      <span className="info-value">{(user.country != null && user.country != 'null')  ? user.country : 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">شهر:</span>
                      <span className="info-value">{(user.state != null && user.state != 'null')  ? user.state : 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">نوع دسترسی:</span>
                      <span className="info-value">
                        {user.user_type == 'user' && 'کاربر معمولی'}
                        {user.user_type == 'owner' && 'مالک'}
                        {user.user_type == 'admin' && 'مدیر'}
                        
                        
                        </span>
                    </div>
                  </Col>
                </Row>
                <h3 style={{textAlign:'right'}}>وضعیت جسمانی در دوره جاری</h3>
                <Row>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">وزن این جلسه:</span>
                      <span className="info-value">{anthropometry.weight ? anthropometry.weight + ' ' + 'کیلوگرم' : 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">وزن هنگام شروع برنامه:</span>
                      <span className="info-value">
                      {anthropometry.result_initial_weight2 
                        ? anthropometry.result_initial_weight2 + ' کیلوگرم' 
                        : (anthropometry.result_initial_weight 
                            ? anthropometry.result_initial_weight + ' کیلوگرم' 
                            : 'ثبت نشده')}
                      </span>
                    </div>
                  </Col>

                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">
                      {
                        typeOfDiet === 'increase' 
                          ? "میزان وزن اضافه شده از شروع برنامه تا کنون:" 
                          : (typeOfDiet === 'decrease' 
                              ? "میزان وزن کم شده از شروع برنامه تا کنون:" 
                              : "میزان وزن کم شده از شروع برنامه تا کنون:")
                      }

                      </span>
                      <span className="info-value">
                      {
                        typeOfDiet === 'increase' 
                          ? (anthropometry.added_weight 
                              ? anthropometry.added_weight + ' کیلوگرم' 
                              : (anthropometry.added_weight_now 
                                  ? anthropometry.added_weight_now + ' کیلوگرم' 
                                  : 0)) 
                          : (anthropometry.Weight_lost 
                              ? anthropometry.Weight_lost + ' کیلوگرم' 
                              : (anthropometry.Weight_lost_now 
                                  ? anthropometry.Weight_lost_now + ' کیلوگرم' 
                                  : 0))
                      }

                      </span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">قد:</span>
                      <span className="info-value">{anthropometry.height != null  ? anthropometry.height + ' ' + 'متر' : 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">نمایه توده بدن این جلسه:</span>
                      <span className="info-value">{anthropometry.bmi != null  ? anthropometry.bmi + 'کیلوگرم بر مترمربع' : 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">نمایه توده بدن هنگام شروع برنامه:</span>
                      <span className="info-value">
                      {
                        anthropometry.initial_bmi2 
                          ? anthropometry.initial_bmi2 + ' کیلوگرم بر مترمربع' 
                          : (anthropometry.initial_bmi 
                              ? anthropometry.initial_bmi + ' کیلوگرم بر مترمربع' 
                              : 'ثبت نشده')
                      }

                      </span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">سن:</span>
                      <span className="info-value">{anthropometry.age != null  ? anthropometry.age + ' ' + 'سال' : 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">جنسیت:</span>
                      <span className="info-value">{anthropometry.gender != null  ? anthropometry.gender : 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">دورمچ:</span>
                      <span className="info-value">{anthropometry.around_wrist_ri != null  ? anthropometry.around_wrist_ri + ' ' + 'سانتی متر' : 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">وضعیت وزنی هنگام شروع برنامه:</span>
                      <span className="info-value">
                      {
                        anthropometry.initial_weightStatus2 
                          ? anthropometry.initial_weightStatus2 
                          : (anthropometry.initial_weightStatus 
                              ? anthropometry.initial_weightStatus 
                              : 'ثبت نشده')
                      }

                      </span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">وضعیت وزنی این جلسه:</span>
                      <span className="info-value">
                      {
                        anthropometry.weightStatus 
                          ? anthropometry.weightStatus 
                          : 'ثبت نشده'
                      }

                      </span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">
                      {
                        anthropometry.Underweight != null 
                          ? 'میزان کمبود وزن باقی مانده:' 
                          : (anthropometry.Overweight != null 
                              ? 'میزان اضافه وزن باقی مانده:' 
                              : (anthropometry.Normal != null 
                                  ? 'نرمال' 
                                  : 'میزان اضافه وزن باقی مانده:'))
                      }

                      </span>
                      <span className="info-value">
                      {
                        anthropometry.Underweight != null 
                          ? anthropometry.Underweight + ' کیلوگرم'
                          : (anthropometry.Overweight != null 
                              ? anthropometry.Overweight + ' کیلوگرم'
                              : (anthropometry.Normal != null 
                                  ? anthropometry.Normal + ' کیلوگرم'
                                  : 'ثبت نشده'))
                      }

                      </span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">دامنه وزن مناسب:</span>
                      <span className="info-value">
                      {
                        (anthropometry.Weightrange != null && anthropometry.Weightrange2 != null) 
                          ? `حداقل(${anthropometry.Weightrange}) حداکثر(${anthropometry.Weightrange2})` 
                          : 'ثبت نشده'
                      }
                      </span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">استخوان بندی:</span>
                      <span className="info-value">
                      {
                        anthropometry.SkeletonText 
                          ? anthropometry.SkeletonText 
                          : 'ثبت نشده'
                      }

                      </span>
                    </div>
                  </Col>
               
                </Row>
                <h3 style={{textAlign:'right'}}>اطلاعات رژیم</h3>
                <Row>


         
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">نوع رژیم غذایی:</span>
                      <span className="info-value">{dietOrder.type_diet != null  ? dietOrder.type_diet: 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">روش رژیم غذایی:</span>
                      <span className="info-value">{dietOrder.dietmethod_text != null  ? dietOrder.dietmethod_text: 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">منوی رژیم غذایی:</span>
                      <span className="info-value">{dietOrder.foodmenu_text != null  ? dietOrder.foodmenu_text : 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">کالری کل این جلسه:</span>
                      <span className="info-value">{dietOrder.total_calories != null  ? dietOrder.total_calories : 'ثبت نشده'}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info-box">
                      <span className="info-label">کالری کل این جلسه:</span>
                      <span className="info-value">{dietOrder.total_calories != null  ? dietOrder.total_calories : 'ثبت نشده'}</span>
                    </div>
                  </Col>
               
                </Row>

                <h3 style={{ textAlign: 'right' }}>بیماری ها</h3>
      <Row>
        {importantQuestions[0]?.option1 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">سردرد های میگرنی دارد:</span>
              <span className="info-value">{importantQuestions[0]?.option1 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[2]?.option3 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">فشار خون بالا دارد:</span>
              <span className="info-value">{importantQuestions[2]?.option3 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[3]?.option4 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">غلظت خون بالا دارد:</span>
              <span className="info-value">{importantQuestions[3]?.option4 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[5]?.option6 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">ریزش مو دارد:</span>
              <span className="info-value">{importantQuestions[5]?.option6 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[6]?.option7 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">کم خونی دارد:</span>
              <span className="info-value">{importantQuestions[6]?.option7 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[8]?.option9 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">پوکی استخوان دارد:</span>
              <span className="info-value">{importantQuestions[8]?.option9 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[10]?.option11 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">مشروبات الکی مصرف میکند:</span>
              <span className="info-value">{importantQuestions[10]?.option11 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[11]?.option12 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">داروهای کورتون دار مصرف میکند:</span>
              <span className="info-value">{importantQuestions[11]?.option12 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[12]?.option13 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">هرمون درمانی انجام میدهد:</span>
              <span className="info-value">{importantQuestions[12]?.option13 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[13]?.option14 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">سنگ کلیه دارد:</span>
              <span className="info-value">{importantQuestions[13]?.option14 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[14]?.option15 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">رفلاکس معده دارد:</span>
              <span className="info-value">{importantQuestions[14]?.option15 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[16]?.option17 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">سندرم روده تحریک پذیر دارد:</span>
              <span className="info-value">{importantQuestions[16]?.option17 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[16]?.option17 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">جراحی برداشت کیسه صفرا داشته:</span>
              <span className="info-value">{importantQuestions[16]?.option17 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[19]?.option20 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">یبوست دارد:</span>
              <span className="info-value">{importantQuestions[19]?.option20 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[20]?.option21 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">بیماری کبد چرب دارد:</span>
              <span className="info-value">{importantQuestions[20]?.option21 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[21]?.option22 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">بیماری آرتروز دارد:</span>
              <span className="info-value">{importantQuestions[21]?.option22 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[22]?.option23 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">بیماری صرع دارد:</span>
              <span className="info-value">{importantQuestions[22]?.option23 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[23]?.option24 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">بیماری MS دارد:</span>
              <span className="info-value">{importantQuestions[23]?.option24 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[24]?.option25 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">بیماری نقرس دارد:</span>
              <span className="info-value">{importantQuestions[24]?.option25 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[25]?.option26 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">بیماری آرتریت روماتوئید دارد:</span>
              <span className="info-value">{importantQuestions[25]?.option26 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[26]?.option27 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">عفونت معده خفیف دارد:</span>
              <span className="info-value">{importantQuestions[26]?.option27 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[27]?.option28 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">بیماری کولیت دارد:</span>
              <span className="info-value">{importantQuestions[27]?.option28 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[28]?.option29 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">پر کاری تیروئید دارد:</span>
              <span className="info-value">{importantQuestions[28]?.option29 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[29]?.option30 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">بیماری افسردگی خفیف دارد:</span>
              <span className="info-value">{importantQuestions[29]?.option30 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
        {importantQuestions[30]?.option31 !== 'خیر' && (
          <Col md="6">
            <div className="info-box">
              <span className="info-label">کم کاری تیروئید دارد:</span>
              <span className="info-value">{importantQuestions[30]?.option31 || 'ثبت نشده'}</span>
            </div>
          </Col>
        )}
      </Row>
                <div className="box2-content-status">
                  <p style={{textAlign:'center',color:'black'}}>نمودار تغیرات وزن در طول زمان</p>
                  <Bar ref={chartRef} data={data} options={options}  plugins={[ChartDataLabels]}/>
                  <button onClick={downloadChart} style={{ fontFamily: 'Dana', marginTop: '10px', padding: '10px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
                  دریافت نمودار
                  </button>

                </div>

                <div className="slider-container">
                    <div><h3 style={{color:'black',textAlign:'center'}}>(تصاویر رو به دوربین)</h3></div>
                    <Swiper
                        spaceBetween={30} // فاصله بین اسلایدها
                        slidesPerView={3} // سه اسلاید نمایش داده شود
                        loop={true} // فعال کردن حلقه برای تکرار اسلایدها
                        breakpoints={{
                        300: {
                            slidesPerView: 1, // برای موبایل یک اسلاید نمایش داده شود
                            spaceBetween: 20,
                        },
                        640: {
                            slidesPerView: 1, // برای موبایل یک اسلاید نمایش داده شود
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2, // برای تبلت دو اسلاید نمایش داده شود
                            spaceBetween: 30,
                        },
                        1024: {
                            slidesPerView: 3, // برای دسکتاپ سه اسلاید نمایش داده شود
                            spaceBetween: 30,
                        },
                        }}
                    >
                       
                        {
                           monthlyPicture != null && 
                           monthlyPicture.map((row, index) => (
                        <SwiperSlide key={index}>
                            <div className="slider-item">
                            <table className="data-table">
                                <thead>
                                <tr>
                                    <th>وزن(کیلوگرم):
                                        <p style={{direction:'ltr',color:'white'}}>
                                        {(() => {
                                    const w_kg = row.w_kg.split(" ");
                                    const weight_kg1 = w_kg[0];
                                    const weight_kg2 = w_kg[1];
                                    const result_weight = parseFloat(weight_kg1 + '.' + weight_kg2);
                                    return result_weight;
                                })()}
                                        </p>
                                        
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td><img src={row.bodyImage} alt={`تصویر ${index}`} className="slider-image" /></td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <td>
                                        <p style={{color:'black'}}>
                                        
                                           تاریخ:{row.date_en}
                                        </p> 
                                       
                                    </td>
                                </tr>
                                </tfoot>
                            </table>
                            </div>
                        </SwiperSlide>
                        ))
                        }
                    </Swiper>
                </div>

                <div className="slider-container">
                    <div><h3 style={{color:'black',textAlign:'center'}}>(تصاویر نیم رخ)</h3></div>
                    <Swiper
                        spaceBetween={30} // فاصله بین اسلایدها
                        slidesPerView={3} // سه اسلاید نمایش داده شود
                        loop={true} // فعال کردن حلقه برای تکرار اسلایدها
                        breakpoints={{
                        300: {
                            slidesPerView: 1, // برای موبایل یک اسلاید نمایش داده شود
                            spaceBetween: 20,
                        },
                        640: {
                            slidesPerView: 1, // برای موبایل یک اسلاید نمایش داده شود
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2, // برای تبلت دو اسلاید نمایش داده شود
                            spaceBetween: 30,
                        },
                        1024: {
                            slidesPerView: 3, // برای دسکتاپ سه اسلاید نمایش داده شود
                            spaceBetween: 30,
                        },
                        }}
                    >
                        {
                            monthlyPicture != null && 
                            monthlyPicture.map((row, index) => (
                        <SwiperSlide key={index}>
                            <div className="slider-item">
                            <table className="data-table">
                                <thead>
                                <tr>
                            
        
                                
                                    <th>وزن(کیلوگرم):
                                        <p style={{direction:'ltr',color:'white'}}>

                                        {(() => {
                                    const w_kg = row.w_kg.split(" ");
                                    const weight_kg1 = w_kg[0];
                                    const weight_kg2 = w_kg[1];
                                    const result_weight = parseFloat(weight_kg1 + '.' + weight_kg2);
                                    return result_weight;
                                })()}
                                        </p>
                                        
                                        
                                        </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td><img src={row.bodyImage2} alt={`تصویر ${index}`} className="slider-image" /></td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <td>
                                    <p style={{color:'black'}}>
                                        
                                        تاریخ:{row.date_en}
                                     </p> 
                                    
                                    </td>
                                </tr>
                                </tfoot>
                            </table>
                            </div>
                        </SwiperSlide>
                        ))
                        }
                    </Swiper>
                </div>


              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default GetUser;
